<template>
    <div>
        <!-- Flash Message -->
        <div v-if="message" class="alert alert-success text-center mb-4">
            {{ message }}
        </div>

        <!-- Errors -->
        <div v-if="errors.length" class="py-4 px-6 bg-red text-white mb-4">
            <ul class="mb-0" :class="{
                'pl-5': errors.length > 1,
                'list-none p-0': errors.length === 1,
            }">
                <li v-for="error in errors" :key="error" v-html="error"></li>
            </ul>
        </div>


        <!-- Avatar -->
        <div class="mx-auto w-20 h-20 rounded-full border-4 border-blue-450 overflow-hidden -mb-10 relative z-10">
            <img
                src="/img/avatar.svg"
                class="block w-full h-full bg-blue-450"
            />
        </div>

        <!-- Form Wrapper -->
        <div class="bg-blue p-6">

            <!-- Info -->
            <div class="alert alert-warning mt-6 mb-5 text-xs">
                You have been invited to join our platform. Please fill in your details below to accept the invitation.
            </div>

            <!-- Form -->
            <form @submit.prevent="submit">
                <!-- Email -->
                <div class="form-group mb-4">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text bg-blue-450 border-blue w-12">
                                <i class="far fa-envelope mx-auto text-white"></i>
                            </div>
                        </div>
                        <input type="email" v-model="form.email" placeholder="Email" required class="form-control p-3 bg-blue-450 border-blue text-white" />
                    </div>
                </div>

                <!-- Name -->
                <div class="form-group mb-4">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text bg-blue-450 border-blue w-12">
                                <i class="far fa-user mx-auto text-white"></i>
                            </div>
                        </div>
                        <input type="text" v-model="form.firstname" placeholder="First Name" required class="form-control p-3 bg-blue-450 border-blue text-white" />
                        <input type="text" v-model="form.lastname" placeholder="Last Name" required class="form-control p-3 bg-blue-450 border-blue text-white" />
                    </div>
                </div>

                <!-- Password -->
                <div class="form-group mb-4">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text bg-blue-450 border-blue w-12">
                                <i class="far fa-lock-alt mx-auto text-white"></i>
                            </div>
                        </div>
                        <input type="password" v-model="form.password" placeholder="Password" required class="form-control p-3 bg-blue-450 border-blue text-white" />
                    </div>
                </div>

                <!-- Confirm Password -->
                <div class="form-group mb-4">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text bg-blue-450 border-blue w-12">
                                <i class="far fa-lock-alt mx-auto text-white"></i>
                            </div>
                        </div>
                        <input type="password" v-model="form.password_confirmation" placeholder="Confirm Password" required class="form-control p-3 bg-blue-450 border-blue text-white" />
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="form-group mb-4">
                    <button type="submit" class="btn btn-lg btn-block btn-success" :disabled="loading || success">
                        Accept Invitation
                        <i v-if="loading || success" class="far fa-spinner-third fa-spin ml-2"></i>
                    </button>
                </div>

                <!-- Success Message -->
                <div v-if="success" class="alert alert-success text-center text-xs mb-4">
                    <!-- I want a very concise success message, perhaps just the word -->
                    <strong>Success!</strong>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        email: String,
        token: String,
        firstname: String,
        lastname: String,
        message: String,
    },
    data() {
        return {
            form: {
                email: this.email,
                firstname: this.firstname,
                lastname: this.lastname,
                password: '',
                password_confirmation: '',
            },
            loading: false,
            errors: [],
            success: false,
        };
    },
    methods: {
        async submit() {
            this.loading = true;
            this.errors = [];

            try {
                // Make the API call to accept the invitation
                const response = await axios.post(`/invitation/${this.token}`, this.getSubmitData());

                // If the response is successful, show a success message and redirect to the dashboard
                this.success = true;
                window.location.href = response.data.redirect;
            } catch (error) {
                // Handle errors
                if (error.response && error.response.data && error.response.data.errors) {
                    // If the error response contains validation errors, display them
                    this.errors = Object.values(error.response.data.errors).flat();
                } else {
                    // If the error response does not contain validation errors, display a generic error message
                    this.errors = ['An unexpected error occurred.'];
                }
            } finally {
                this.loading = false;
            }
        },

        getSubmitData() {
            // Merge form data with CSRF token
            return { ...this.form, _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content') };
        },
    },
};
</script>
